import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "./AuthContext";
import { JobModal } from "../pages/Jobs";
import { Plus, Briefcase, ExternalLink, Loader2 } from "lucide-react";

export default function ClientJobsPanel({ clientId, allClients }) {
  const [jobs, setJobs] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const load = useCallback(() => {
    axios.get(`${API_BASE}/jobs`, { params: { client_id: clientId } }).then((r) => setJobs(r.data || [])).catch(() => setJobs([]));
  }, [clientId]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { axios.get(`${API_BASE}/workflows`).then((r) => setTemplates(r.data || [])).catch(() => {}); }, []);

  if (!jobs) return <div className="p-5"><Loader2 className="animate-spin text-[var(--ink-3)]" size={16} /></div>;
  return (
    <div className="p-5 space-y-3" data-testid="client-jobs-panel">
      <div className="flex items-center justify-between">
        <div className="text-[13px] text-[var(--ink-2)]" data-testid="client-jobs-count">{jobs.length} job{jobs.length === 1 ? "" : "s"}</div>
        <button className="btn-primary" onClick={() => setShowNew(true)} data-testid="client-create-job-btn"><Plus size={13} /> Create job</button>
      </div>
      {jobs.length === 0 && <div className="text-[12px] text-[var(--ink-3)] py-6 text-center border border-dashed border-[var(--border)] rounded-md">No jobs yet.</div>}
      <ul className="space-y-2">
        {jobs.map((j) => (
          <li key={j.job_id}>
            <a href={`/jobs?job_id=${j.job_id}`} target="_blank" rel="noreferrer" data-testid={`client-job-${j.job_id}`}
               className="card p-3 flex items-center gap-3 hover:border-[var(--ink)] transition-colors">
              <Briefcase size={14} className="text-[var(--ink-3)]" />
              <div className="flex-1 min-w-0">
                <div className="text-[13px] font-medium truncate">{j.title}</div>
                <div className="text-[11px] text-[var(--ink-3)]">{j.status} · {j.due_at ? `due ${new Date(j.due_at).toLocaleDateString()}` : "no due date"}</div>
              </div>
              <ExternalLink size={12} className="text-[var(--ink-3)]" />
            </a>
          </li>
        ))}
      </ul>
      {showNew && (
        <JobModal clients={allClients?.length ? allClients : [{ client_id: clientId, name: "This client" }]} templates={templates}
          defaultClientId={clientId} onClose={() => setShowNew(false)} onCreated={() => { setShowNew(false); load(); }} />
      )}
    </div>
  );
}
